import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { ServicesSection } from './components/ServicesSection';
import { FoundersSection } from './components/FoundersSection';
import { NetworkSection } from './components/NetworkSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { RobFridPage } from './pages/RobFridPage';
import { ScottBlairPage } from './pages/ScottBlairPage';
const HomePage = () => <main data-id="element-0">
    <HeroSection data-id="element-1" />
    <MissionSection data-id="element-2" />
    <ServicesSection data-id="element-3" />
    <FoundersSection data-id="element-4" />
    <NetworkSection data-id="element-5" />
    <ContactSection data-id="element-6" />
  </main>;
export function App() {
  return <BrowserRouter data-id="element-7">
      <div className="min-h-screen bg-navy-900 text-white selection:bg-ice-500 selection:text-navy-900" data-id="element-8">
        <Navbar data-id="element-9" />
        <Routes data-id="element-10">
          <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
          <Route path="/rob-frid" element={<RobFridPage data-id="element-14" />} data-id="element-13" />
          <Route path="/scott-blair" element={<ScottBlairPage data-id="element-16" />} data-id="element-15" />
        </Routes>
        <Footer data-id="element-17" />
      </div>
    </BrowserRouter>;
}